<template>
    <div class="position-box">
        <div class="head">
            <img class="back" src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('c2c.tjpz')}}</div>
        </div>
        <div class="cotainer">
          <div class="tips">{{$t('c2c.tjzzfb')}}</div>
          <div class="img-box">
            <img class="upload" v-if="img1" @click="upload(1)" :src="img1" alt="">
            <img class="upload" v-else @click="upload(1)" src="@/assets/new3/tijiao.png" alt="">
          </div>
          <div class="upload-wrap">
          <div class="upload-box">
            <div class="text">{{$t('c2c.tjjzzm')}}</div>
            <div class="img-box">
              <img class="img" v-if="img2" @click="upload(2)" :src="img2" alt="">
              <img class="img" v-else @click="upload(2)" src="@/assets/new3/tijiao.png" alt="">
            </div>
          </div>
          <div class="upload-box">
            <div class="text">{{$t('c2c.tjjzfm')}}</div>
            <div class="img-box">
              <img class="img" v-if="img3" @click="upload(3)" :src="img3" alt="">
              <img class="img" v-else @click="upload(3)" src="@/assets/new3/tijiao.png" alt="">
            </div>
          </div>
        </div>
        <div class="tx-box">
          <div class="title">{{$t('c2c.psts1')}}</div>
          <ul>
            <li class="ps-tips">{{$t('c2c.psts2')}}</li>
            <li class="ps-tips">{{$t('c2c.psts3')}}</li>
          </ul>
        </div>
        </div>
        <div class="btn-sure" @click="sure">{{$t('c2c.tj')}}</div>
        <loading v-show="isLoad"></loading>
        <input class="___input" type="file" ref="foreheadCir" mutiple="mutiple" accept="image/*" style="display: none;">
    </div>
</template>

<script>
import loading from '@/components/loading.vue'
import lrz from "lrz";
export default {
    name: 'c2cCreate',
    data () {
        return {
          token: '',
          img1: '',
          img2: '',
          img3: '',
          uploadId: 1,
          isLoad: false,
          count: 1
        }
    },
    created(){
      this.token = localStorage.getItem('token') || '';
    },
    mounted() {
      this.getmarketList();
      this.getCurrencysFiat();
    },
    methods: {
      back(){
        this.$router.push('/c2c')
      },
      getmarketList() {
        var that = this;
        let params = {
            token: '',
            id: 1,
            classify: 0
        }
        this.$ajax.get('/web/getmarketList',{params}).then((res) => {
          let resData = res.data.data;
          that.currencyList = resData;
        }).catch(function(err){
            console.log(err)
        })
      },
      selectBzShow(){
        this.isSelect = true
      },
      hide(){
        this.isSelect = false
      },
      select(text){
        this.currency = text;
        this.isSelect = false;
      },
      getCurrencysFiat(){
        this.$ajax.get('/Web/currencysFiat',{}).then((res) => {
          let resData = res.data.data;
          // console.log(resData)
        }).catch(function(err){
            console.log(err)
        })
      },
      sure(){
        if(this.img1 == '' || this.img1 == null){
          this.$toast.center(this.$t('c2c.qsczzfb'));
          return;
        }
        if(this.img2 == '' || this.img2 == null){
          this.$toast.center(this.$t('c2c.qscjzzm'));
          return;
        }
        if(this.img3 == '' || this.img3 == null){
          this.$toast.center(this.$t('c2c.qscjzfm'));
          return;
        }
        let params = {
          ctoc_payimg: this.img1,
          ctoc_cert0: this.img2,
          ctoc_cert1: this.img3,
        }
        if(this.count == 1){
          this.count = 0;
        }else{
            return false;
        }
        this.$ajax.post('/Web/ctocCert',params).then((res) => {
          let resData = res.data;
          if(resData.code == 0 || resData.code == 4 || resData.code == 7){
              this.$toast.center(this.$t('status.statusText')[2]);
              setTimeout(() => {
                this.count = 1;
                this.$router.push('/c2cOrder')
              }, 1000)
          }else{
            this.count = 1;
            this.$toast.center(resData.message);
            return;
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      upload(id){
          var that = this;
          that.uploadId = id;
          this.uploadimg(function (res) {

          })
      },
      uploadimg(callback){
			    let that = this;
			    that.ele_input(function(res) {
            if (res.length > 0) {
              var formdata = new FormData();
              for (var i = 0, len = res.length; i < len; i++) {
                lrz(res[0]).then(function (rst) {
                  var formdata = new FormData();
                  let file = new window.File([rst.file],rst.origin.name, {type: rst.file.type});
                  formdata.append('file', file);
                  formdata.append('token', that.token);
                  formdata.append('app', 'h5');
                  that.isLoad = true;
                  $.ajax({
                    url: that.domain + "/web/uploadImg",
                    type: "POST",
                    data: formdata,
                    cache: false,
                    processData: false,
                    contentType: false,
                    success: function(data) {
                      if (typeof data == 'string') data = JSON.parse(data.data)
                      if (data && data.code == 0) {
                        that.isLoad = false;
                        if(that.uploadId == 1){
                          that.img1 = data.data.url;
                        }else if(that.uploadId == 2){
                          that.img2 = data.data.url;
                        }else if(that.uploadId == 3){
                          that.img3 = data.data.url;
                        }
                      }else{
                        that.isLoad = false;
                        that.$toast.center(data.message);
                        return;
                      }
                    },error: function(data) {
                      that.isLoad = false;
                      that.$toast.center(data.message);
                      return;
                    }
                  });
                })
              }
            }
			  })
		  },
      ele_input(callback){
        var inputs = document.querySelector('.___input')
        if (!!inputs) {
          inputs.onchange = null
          inputs.onclick = null
          // inputs.remove(0)
          // inputs.removeChild && inputs.removeChild(0)
        }
        inputs.onchange = function() {
          var arr = []
          for (var i = 0, len = this.files.length; i < len; i++) {
            arr.push(this.files[i])
          }
          callback(arr)
        }
        inputs.click();
      },
      hideLoad(){
          this.isLoad = false;
      },
    },
    components:{
		  loading
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
  .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.2rem;
        padding: 0 .3rem;
        color: #fff;
        line-height: 1.2rem;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .3rem;
        margin-top: -.3rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
      position: absolute;
      top: 1.2rem;
      bottom: 3.4rem;
      width: 100%;
      background: transparent;
      overflow-y: scroll;
    }
    .tips{
      width: 50%;
      padding: .4rem .48rem .2rem;
      color: #fff;
      font-size: .48rem;
      text-align: center;
    }
    .img-box{
      width: 50%;
      margin: 0 .48rem;
      text-align: center;
    }
    .img-box .upload{
      width: 4.08rem;
      height: 3.55rem;
      margin: .5rem .48rem .5rem;
      opacity: 0.7;
    }
    .upload-wrap{
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      margin: 0 .48rem;
    }
    .upload-wrap .upload-box{
      width: 50%;
      text-align: center;
    }
    .upload-wrap .upload-box .img{
      width: 4.08rem;
      height: 3.55rem;
    }
    .upload-wrap .text{
      height: 1rem;
      padding-bottom: .6rem;
      color: #fff;
      font-size: .48rem;
      text-align: center;
    }
    .tx-box{
      margin: 1.2rem .64rem 0 .55rem;
      padding: .52rem .38rem .2rem;
	    background: rgba(30,27,73,.3);
    }
    .tx-box .title{
      padding-bottom: .4rem;
      color: #cbcbcb;
      font-size: .34rem;
    }
    .tx-box ul{
      margin-left: .38rem;
    }
    .tx-box .ps-tips{
      padding-bottom: .32rem;
      color: #cbcbcb;
      font-size: .34rem;
      list-style: square;
    }
    .btn-sure{
      position: absolute;
      left: .48rem;
      right: .48rem;
      bottom: 0;
      height: 1.28rem;
      margin: 1.5rem .48rem .6rem;
      color: #fff;
      font-size: .56rem;
      line-height: 1.28rem;
      background-color: #0060ff;
      border-radius: 0.2rem;
      text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/c2cCredentials.vue